import React from 'react'
import { AuthProvider } from './src/auth/AuthContext'
import './src/styles/global.css'

export const wrapRootElement = ({ element }) => {
  return <AuthProvider>{element}</AuthProvider>
}

export const onClientEntry = () => {
  if (typeof window !== 'undefined') {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
    if (!window.location.hash) {
      window.scrollTo(0, 0)
    }
    window.addEventListener('beforeunload', () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual'
      }
      if (!window.location.hash) {
        window.scrollTo(0, 0)
      }
    })
  }
}

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location && location.hash) {
    return true
  }
  window.scrollTo(0, 0)
  return [0, 0]
}
